document.addEventListener('DOMContentLoaded', function() {
  function setHeroVideoHeight() {
    // Find all hero video sections with full_screen layout
    const heroSections = document.querySelectorAll('.hero-video__sec[data-layout-height="full_screen"]');
    
    if (heroSections.length === 0) return;
    
    heroSections.forEach(function(heroVideoSec) {
      const heroSection = heroVideoSec.querySelector('[class*="section-"][class*="-settings"]');
      if (!heroSection) return;
      
      const announcementBar = document.querySelector('.custom-announcement');
      const headerSection = document.querySelector('.header-section');
      
      let totalHeight = 0;
      
      if (announcementBar) {
        const announcementHeight = announcementBar.offsetHeight;
        totalHeight += announcementHeight;
      }
      
      if (headerSection) {
        const headerHeight = headerSection.offsetHeight;
        totalHeight += headerHeight;
      }
      
      if (totalHeight > 0) {
        const calculatedHeight = window.innerHeight - totalHeight;
        heroSection.style.height = calculatedHeight + 'px';
      } else {
        heroSection.style.height = '100vh';
      }
    });
  }
  
  // Run on load
  setHeroVideoHeight();
  
  // Run on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setHeroVideoHeight, 250);
  });
});
